<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card card-body">
        <template v-if="!hudury.enabled || hudury.status == 0">
            <div class="alert alert-danger text-center g">
                <h3>
                    قم بتفعيل الربط مع حضوري أولاً.
                </h3>
            </div>
        </template>
        <template v-else>
            <h4 class="text-center">
                استيراد تقرير فترة من <img src="/assets/images/hudury.png" width="28" alt=""> حضوري
            </h4>
            <div class="alert alert-info g">
                <span class="text-dark">
                    أصبح استيراد تقرير الفترة يتم من <b>أداة مساعد حضوري</b> مباشرة، لأن نظام حضوري أوقف الاستعلام من خارج موقعه.
                    <br><br>
                    <b>الخطوات:</b>
                    <br>1. افتح موقع حضوري في المتصفح المثبت عليه الأداة.
                    <br>2. من نافذة «الإرسال إلى التحضير الذكي» أسفل الصفحة اضغط <b>📆 تقرير فترة</b>.
                    <br>3. اختر الفترة ثم اضغط <b>إرسال الفترة</b>، وستظهر التقارير هنا بعد انتهاء الإرسال.
                </span>
            </div>
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td>حالة الأداة</td>
                        <td>
                            <span v-if="hudury.status == 1 && hudury.online" class="btn btn-sm btn-success" style="padding: 5px">
                                <i class="fa fa-check"></i>
                                الأداة متصلة الآن (صفحة حضوري مفتوحة)
                            </span>
                            <span v-if="hudury.status == 1 && !hudury.online" class="btn btn-sm btn-warning" style="padding: 5px">
                                الأداة غير متصلة — افتح صفحة حضوري
                            </span>
                            <span v-if="hudury.status == 2" class="btn btn-sm btn-danger" style="padding: 5px">
                                انتهت جلسة حضوري، سجّل الدخول في حضوري
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>آخر إرسال من حضوري</td>
                        <td>{{ hudury.last_active }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="col-12 text-center g">
                <a href="https://hather-ui.moe.gov.sa/" class="btn btn-success" target="_blank">
                    <i class="fa fa-external-link"></i>
                    فتح موقع حضوري
                </a>
            </div>
        </template>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            hudury: {
                enabled: false,
                status: 0,
                users: [],
                last_active: "--"
            },
            inter: null
        }
    },
    created(){
        if(!(checkPer("teachers|hudury") || checkPer("teachers|reports|edit"))){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.gett()
        g.inter = setInterval(() => {
            g.gett()
        }, 5000);
    },
    beforeDestroy(){
        if(this.inter){
            clearInterval(this.inter)
        }
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/teachers/hudury/settings', {
                jwt: g.user.jwt
            }).then(function(r){
                g.hudury = r.response
            })
        }
    }
}
</script>

<style>

</style>
